const getters = {
  routeTimezone: state => route => state.routes[route] ? state.routes[route].replace(/_/g, ' ') : null,

  timeZones: state => {
    return state.timeZones ? state.timeZones.map(timeZone => timeZone.replace(/_/g, ' ')) : [];
  },
};

export default getters;
